import { memo } from 'react';
import { format, addMonths, subMonths } from 'date-fns';
import { fi } from 'date-fns/locale';

import Button from '@material-ui/core/Button';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

import { useStyles } from './style';

interface Props {
  date: Date;
  onChange: (date: Date | null) => void;
}

const ServicesMonthPicker: React.FC<Props> = ({ date, onChange }) => {
  const classes = useStyles();

  const nextMonth = () => {
    onChange(addMonths(date, 1));
  };

  const prevMonth = () => {
    onChange(subMonths(date, 1));
  };

  return (
    <div className={classes.root}>
      <Button onClick={prevMonth} classes={{ root: classes.button }}>
        <ArrowLeftIcon className={classes.icon} />
      </Button>
      <span className={classes.monthName}>
        {format(date, 'MMMM', { locale: fi })}
      </span>
      <Button onClick={nextMonth} classes={{ root: classes.button }}>
        <ArrowRightIcon className={classes.icon} />
      </Button>
    </div>
  );
};

export default memo(ServicesMonthPicker);
